import { openLotModal } from '../modules/ui';
import { handleImageLoadError } from '../modules/image';
import type { EventHandlerDeps } from './globalEventTypes';
import { setupCloseHandlers } from './modal/closeHandlers';
import { setupFormSubmitHandlers } from './modal/formSubmitHandlers';
import { setupCreditAdjustmentHandlers } from './modal/creditAdjustmentHandlers';
import type { ModalHandlerDeps } from './modal/types';

export function setupModalLifecycleHandlers(deps: EventHandlerDeps): void {
  setupCloseHandlers(deps as ModalHandlerDeps);
  setupFormSubmitHandlers(deps as ModalHandlerDeps);
  setupCreditAdjustmentHandlers(deps as ModalHandlerDeps);

  const { els } = deps;

  if (els.openLotForm) {
    els.openLotForm.addEventListener('click', () => {
      deps.prepareLotFormForCreate();
      openLotModal({ mode: 'create' });
    });
  }

  if (els.imagesModalContent) {
    els.imagesModalContent.addEventListener('error', handleImageLoadError, true);
  }

  if (els.lotDetailsModalContent) {
    els.lotDetailsModalContent.addEventListener('error', handleImageLoadError, true);
  }
}
